export function getLocationCount(value) {
  let count = (value?.resources || []).length
  return `${count} location${count === 1 ? '' : 's'}`
}
